import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ApplicationError, HSSComponentProvider } from '@crx-dev/hss-react-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import {
    configureMakeRequest,
    ErrorBoundary,
    HSSInfrastructureProvider,
    logger
} from '@crx-dev/hss-react-infrastructure';
import ScrollToTop from './Areas/App/ScrollToTop';
import AuthProvider from './Infrastructure/auth/AuthProvider';
import * as auth from './Infrastructure/auth/keyCloakAuth';
import { makeRequest } from '@crx-dev/hss-react-infrastructure/dist';
import SettingsProvider from './Infrastructure/settings/SettingsProvider';
let keyCloakRealm = process.env.REACT_APP_ENV_DEV_REALM as string;

logger.configure({
    enableConsoleLogging: true,
    enableApiLogging: true,
    logLevel: 'Info',
    apiLoggingUrl: '/api/v1/Logging',
    sessionId: uuidv4(),
    clientId: 'react-client'
});

async function initializeApp() {
    logger.log('Info', 'Calling API to get Keycloak settings...');

    const keycloakSettings = await makeRequest({
        method: 'GET',
        path: '/api/v1/clientSettings/keycloakSettings'
    });

    configureMakeRequest({
        addHeadersOnEachRequest: async () => {
            const token = await auth.getToken();
            return {
                Authorization: `Bearer ${token}`
            };
        }
        // log: (level, message) => {
        //     logger.log(level, message);
        // }
    });

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false
            }
        }
    });

    const userInfo = await auth.init(keycloakSettings, keyCloakRealm);

    if (!userInfo) {
        ReactDOM.render(<div>Unable to connect to KeyCloak Server</div>, document.getElementById('root'));
        return;
    }

    logger.log('Info', `Client: Started: ${window.location}`);
    logger.log('Info', `Client: Using realms ${keyCloakRealm}`);

    if (window.location.pathname !== '/') {
        window.history.replaceState(null, '', '/');
    }

    ReactDOM.render(
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <AuthProvider userInfo={userInfo}>
                    <ErrorBoundary errorComponent={() => <ApplicationError />}>
                        <HSSInfrastructureProvider>
                            <HSSComponentProvider maxContentWidth={1340} primaryThemeColor="RositaBlue">
                                <Router>
                                    <SettingsProvider>
                                        <ScrollToTop />
                                        <App />
                                    </SettingsProvider>
                                </Router>
                            </HSSComponentProvider>
                        </HSSInfrastructureProvider>
                    </ErrorBoundary>
                </AuthProvider>
            </QueryClientProvider>
        </React.StrictMode>,
        document.getElementById('root')
    );
}

initializeApp();
